module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('navbar'), _vm._v(" "), _c('section', {
    staticClass: "head row md-whiteframe center-xs middle-xs",
    attrs: {
      "id": "head"
    }
  }, [_c('div', {
    staticClass: "gradient"
  }), _vm._v(" "), _c('div', {
    staticClass: "column main"
  }, [_c('div', {
    staticClass: "intro col-md-offset-1 col-md-10 row middle-xs"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('animated-logo', {
    attrs: {
      "primaryColor": "#ffffff",
      "secondaryColor": "#2196f3"
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('home.intro'))
    }
  })], 1), _vm._v(" "), (_vm.introLoaded) ? _c('div', {
    staticClass: "col-md-5 col-xs-12"
  }, [_c('iframe', {
    attrs: {
      "width": "560",
      "height": "315",
      "src": "https://www.youtube.com/embed/f_MiF80J04M?rel=0&showinfo=0",
      "frameborder": "0",
      "allow": "autoplay; encrypted-media",
      "allowfullscreen": ""
    }
  })]) : _vm._e()])])]), _vm._v(" "), _c('section', {
    staticClass: "row first col-md-offset-1 col-md-10 between-md"
  }, [_c('md-card', [_c('md-card-content', [_c('store-links', {
    attrs: {
      "type": _vm.type
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('section', {
    staticClass: "row col-md-offset-1 col-md-10"
  }, [_c('md-card', [_c('md-card-content', {
    staticClass: "row features"
  }, [_c('div', {
    staticClass: "col-md-7 row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icons/icon-time.png")
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("home.featuresecond")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.featureseconddesc")))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icons/icon-graph.png")
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("home.featurethird")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.featurethirddesc")))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icons/icon-calendar.png")
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("home.featurefourth")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.featurefourthdesc")))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icons/icon-stetho.png")
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("home.featurefirst")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.featurefirstdesc")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-xs-12 row center-xs bottom-xs"
  }, [_c('div', {
    staticClass: "intro-mobile"
  }, [_c('div', {
    ref: "variableA",
    staticClass: "variable",
    staticStyle: {
      "z-index": "3"
    },
    style: ({
      'background-image': 'url(' + _vm.introImage(0) + ')'
    })
  }), _vm._v(" "), _c('div', {
    ref: "variableB",
    staticClass: "variable",
    staticStyle: {
      "z-index": "2"
    },
    style: ({
      'background-image': 'url(' + _vm.introImage(1) + ')'
    })
  }), _vm._v(" "), _c('div', {
    ref: "variableC",
    staticClass: "variable",
    staticStyle: {
      "z-index": "1"
    },
    style: ({
      'background-image': 'url(' + _vm.introImage(2) + ')'
    })
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/phone_en_0.jpg")
    }
  })])])])], 1)], 1), _vm._v(" "), _c('section', {
    staticClass: "posts row col-md-offset-1 col-md-10 between-md"
  }, [_c('feed-view')], 1), _vm._v(" "), _c('section', {
    staticClass: "row col-md-offset-1 col-md-10"
  }, [_c('md-card', [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.$t("home.supportTitle")))])]), _vm._v(" "), _c('md-card-content', {
    staticClass: "row support"
  }, [_c('div', {
    staticClass: "col-sm-3 col-xs-12"
  }, [_c('a', {
    attrs: {
      "href": "http://www.elte.hu",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/support/elte.jpg")
    }
  }), _c('br'), _vm._v("\n\t\t\t\t\t\tELTE\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-12"
  }, [_c('a', {
    attrs: {
      "href": "https://www.eitdigital.eu/eit-digital-academy/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/support/digitalacademy.jpg")
    }
  }), _c('br'), _vm._v("\n\t\t\t\t\t\tEIT Digital Academy\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-12"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ujbuda.hu/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/support/ujbuda.png")
    }
  }), _c('br'), _vm._v("\n\t\t\t\t\t\tÚjbudai Önkormányzat\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-12"
  }, [_c('a', {
    attrs: {
      "href": "http://www.szanthoandras.hu/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/support/szanthoestarsa.jpg")
    }
  }), _c('br'), _vm._v("\n\t\t\t\t\t\tSzánthó és Társa\n\t\t\t\t\t")])])])], 1)], 1), _vm._v(" "), _c('section', {
    staticClass: "team row col-md-offset-1 col-md-10"
  }, [_c('md-card', [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.$t("contact_us")))]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v(_vm._s(_vm.$t("report_feedback")))])]), _vm._v(" "), _c('md-card-content', {
    staticClass: "center-xs"
  }, [_c('div', {
    staticClass: "row center-xs"
  }, _vm._l((_vm.team), function(member) {
    return _c('span', {
      staticClass: "member col-sm-2 col-xs-12"
    }, [_c('a', {
      attrs: {
        "href": _vm.contactMail()
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.teamImgUrl(member.image)
      }
    })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(member.first))]), _c('br'), _vm._v(_vm._s(member.last)), _c('br'), _vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t(member.desc)) + "\n\t\t\t\t\t")])
  })), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("home.specialThanks")))]), _vm._v(" "), _c('div', {
    staticClass: "row center-xs"
  }, _vm._l((_vm.thanksFor), function(person) {
    return _c('span', {
      staticClass: "col-sm-2 col-xs-12"
    }, [_c('i', [_c('b', [_vm._v(_vm._s(person.first))]), _c('br'), _vm._v(_vm._s(person.last))])])
  })), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row center-xs directly"
  }, [_c('md-button', {
    staticClass: "md-primary md-raised",
    attrs: {
      "href": _vm.contactMail()
    }
  }, [_vm._v(_vm._s(_vm.$t("contact_us_directly")) + " hello@pulmoment.com")])], 1)])], 1)], 1), _vm._v(" "), _c('section', {
    staticClass: "row col-md-offset-1 col-md-10 between-md"
  }, [_c('md-card', [_c('md-card-content', [_c('store-links', {
    attrs: {
      "type": _vm.type
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "videoDialog"
  }, [_c('md-dialog-content', [_c('iframe', {
    staticClass: "video",
    attrs: {
      "width": "853",
      "height": "480",
      "src": "https://www.youtube.com/embed/f_MiF80J04M?rel=0&showinfo=0",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })])], 1), _vm._v(" "), _c('section', {
    staticClass: "footer row col-md-offset-1 col-md-10"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo_icon_grey.png")
    }
  }), _c('br'), _vm._v("\n\t\t" + _vm._s(new Date().getFullYear()) + " - Pulmoment - All rights reseverd"), _c('br'), _vm._v(" "), _vm._m(0)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("Icons made by "), _c('a', {
    attrs: {
      "href": "http://www.freepik.com",
      "title": "Freepik"
    }
  }, [_vm._v("Freepik")]), _vm._v(" from "), _c('a', {
    attrs: {
      "href": "http://www.flaticon.com",
      "title": "Flaticon"
    }
  }, [_vm._v("www.flaticon.com")]), _vm._v(" is licensed by "), _c('a', {
    attrs: {
      "href": "http://creativecommons.org/licenses/by/3.0/",
      "title": "Creative Commons BY 3.0"
    }
  }, [_vm._v("CC BY 3.0")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-221b7304!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 412
// module chunks = 2